import React, { createContext, useContext, useState } from 'react';

const QueryBuilderOverlayContext = createContext();

export const useQueryBuilderOverlay = () => {
  const context = useContext(QueryBuilderOverlayContext);
  if (!context) {
    throw new Error('useQueryBuilderOverlay must be used within QueryBuilderOverlayProvider');
  }
  return context;
};

export const QueryBuilderOverlayProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [initialQuery, setInitialQuery] = useState(null);

  const openOverlay = (options = {}) => {
    if (options.initialQuery) {
      setInitialQuery(options.initialQuery);
    }
    setIsOpen(true);
    setIsMinimized(options.minimized || false);
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setIsMinimized(false);
    setInitialQuery(null);
  };

  const toggleMinimized = () => {
    setIsMinimized(!isMinimized);
  };

  const value = {
    isOpen,
    isMinimized,
    initialQuery,
    openOverlay,
    closeOverlay,
    toggleMinimized,
  };

  return (
    <QueryBuilderOverlayContext.Provider value={value}>
      {children}
    </QueryBuilderOverlayContext.Provider>
  );
};
